export default "__VITE_ASSET__CoJXyqMq__"